module.exports = __webpack_public_path__ + "img/Platform_Gradients-11.9bd8543a.jpg";